// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ebc01e06","239":"e0c0a789","453":"d6b43791","455":"6f847d5d"}[chunkId] + ".chunk.js";
};